import React from 'react'

export default function File (props) {
  return (
    <a href={props.url} className="dm-file dm-download-icon-parent" download>
      <div className="dm-file__icon">
        <div className="dm-download-icon" />
      </div>
      <div className="dm-file__text-container">
        {props.title && (
          <div className="dm-file__title">{props.title}</div>
        )}
        {props.text && (
          <div className="dm-file__text" dangerouslySetInnerHTML={{ __html: props.text }} />
        )}
      </div>
    </a>
  )
}